"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Rule = /*#__PURE__*/function () {
  function Rule(regex, replacement) {
    _classCallCheck(this, Rule);

    this.regex = regex;
    this.replacement = replacement;
  }

  _createClass(Rule, [{
    key: "apply",
    value: function apply(word) {
      if (!this.regex.test(word)) return null;
      return word.replace(this.regex, this.replacement);
    }
  }]);

  return Rule;
}();

var Vocabulary = /*#__PURE__*/function () {
  function Vocabulary() {
    _classCallCheck(this, Vocabulary);

    _defineProperty(this, "plurals", []);

    _defineProperty(this, "singulars", []);

    _defineProperty(this, "uncountables", []);
  }

  _createClass(Vocabulary, [{
    key: "isUncountable",
    value: function isUncountable(word) {
      return this.uncountables.includes(word);
    }
  }, {
    key: "applyRules",
    value: function applyRules(rules, word, skipFirstRule) {
      if (word == null) return word;
      if (this.isUncountable(word)) return word;
      var result = word;
      var end = skipFirstRule ? 1 : 0;

      for (var i = rules.length - 1; i >= end; i--) {
        if ((result = rules[i].apply(word)) != null) break;
      }

      return result;
    }
    /**
     * Adds a word to the vocabulary which cannot easily be pluralised/singularised by regex
     * @param singular The singular form of the word
     * @param plural The plural form of the word
     * @param matchEnding True to match these words on their own as well as at the end of longer words
     */

  }, {
    key: "addIrregular",
    value: function addIrregular(singular, plural) {
      var matchEnding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (matchEnding) {
        this.addPlural("(".concat(singular[0], ")").concat(singular.substring(1), "$"), "$1" + plural.substring(1));
        this.addSingular("(".concat(plural[0], ")").concat(plural.substring(1), "$"), "$1" + singular.substring(1));
      } else {
        this.addPlural("^".concat(singular, "$"), plural);
        this.addSingular("^".concat(plural, "$"), singular);
      }
    }
    /**
     * Adds an uncountable word to the vocabulary
     * @param word Word to be added to the list of uncountables
     */

  }, {
    key: "addUncountable",
    value: function addUncountable(word) {
      this.uncountables.push(word);
    }
    /**
     * Adds a rule to the vocabulary that does not follow trivial rules for pluralisation
     * @param rule Regex to be matched. If it is a string it will be converted with `i` flag
     * @param replacement Regex replacement
     */

  }, {
    key: "addPlural",
    value: function addPlural(rule, replacement) {
      if (typeof rule === "string") rule = new RegExp(rule, "i");
      this.plurals.push(new Rule(rule, replacement));
    }
    /**
     * Adds a rule to the vocabulary that does not follow trivial rules for singularisation
     * @param rule Regex to be matched. If it is a string it will be converted with `i` flag
     * @param replacement Regex replacement
     */

  }, {
    key: "addSingular",
    value: function addSingular(rule, replacement) {
      if (typeof rule === "string") rule = new RegExp(rule, "i");
      this.singulars.push(new Rule(rule, replacement));
    }
    /**
     * Pluralises the provided input considering irregular words
     * @param word Word to be pluralised
     * @param inputIsKnownToBeSingular Normally you call `pluralize` on singular words, but if you're unsure set this to false
     */

  }, {
    key: "pluralize",
    value: function pluralize(word) {
      var inputIsKnownToBeSingular = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var result = this.applyRules(this.plurals, word, false);
      if (inputIsKnownToBeSingular) return result !== null && result !== void 0 ? result : word;
      var asSingular = this.applyRules(this.singulars, word, false);
      var asSingularAsPlural = this.applyRules(this.plurals, asSingular, false);
      if (asSingular != null && asSingular !== word && asSingular + "s" !== word && asSingularAsPlural === word && result !== word) return word;
      return result;
    }
    /**
     * Singularises the provided input considering irregular words
     * @param word Word to be singularised
     * @param inputIsKnownToBePlural Normally you call `singularize` on plural words, but if you're unsure set this to false
     * @param skipSimpleWords Skip singularising simple words that have an 's' on the end (assumes default vocabulary)
     */

  }, {
    key: "singularize",
    value: function singularize(word) {
      var inputIsKnownToBePlural = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var skipSimpleWords = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var result = this.applyRules(this.singulars, word, skipSimpleWords);
      if (inputIsKnownToBePlural) return result !== null && result !== void 0 ? result : word;
      var asPlural = this.applyRules(this.plurals, word, false);
      var asPluralAsSingular = this.applyRules(this.singulars, asPlural, false);
      if (asPlural !== word && word + "s" !== asPlural && asPluralAsSingular === word && result !== word) return word;
      return result;
    }
  }]);

  return Vocabulary;
}();

exports["default"] = Vocabulary;